import { Navigate, useLocation } from "react-router-dom";

import { PAGE_ROUTES, TRAINING_LOG_ACCESS } from "../Helpers/Enums";
import { GetLocalStorageData } from "../Helpers/Utilities";

const ProtectedRoute = ({ children }) => {
  const user = GetLocalStorageData("eUser");

  const location = useLocation();

  const trainingLogNotAllowed =
    location.pathname === PAGE_ROUTES.TRAINING_LOG &&
    !Object.values(TRAINING_LOG_ACCESS).includes(user?.rankId);

  const trainingLogBookNotAllowed =
    location.pathname === PAGE_ROUTES.TRAINING_LOG_BOOK &&
    Object.values(TRAINING_LOG_ACCESS).includes(user?.rankId);

  if (!user) {
    // Not logged in
    return <Navigate to="/" replace />;
  }

  if (trainingLogNotAllowed || trainingLogBookNotAllowed) {
    // Not allowed
    return <Navigate to="/ErrorPage" replace />;
  }

  // Authorized
  return children;
};

export default ProtectedRoute;
